<template lang="pug">
.navbar.gap-3.flex.items-center.justify-between.h-12.px-4.border-b.border-neutral.bg-white
    //- +++++++++++++++++++++++++++++++++++
    //- SMALL
    //- +++++++++++++++++++++++++++++++++++

    .navbar-brand.flex-1.flex(
        class="sm:block hidden"
    )
        .flex.flex-1.justify-between
            .flex.self-center.flex-1.gap-3(v-if="title || !!$slots.title")
                slot(name="title")
                    .flex.self-center(v-if="!hideLink && $route.path !== '/'")
                        UButton.cursor-pointer(
                            :to="pageUp"
                            icon="mdi:chevron-left"
                            color="secondary"
                            size="sm"
                            variant="soft"
                        )
                    .flex.self-center(
                        v-if="title"
                    )
                        .flex.self-center.pt-1(class="font-bold text-sm text-gray-800 dark:text-gray-200 hover:text-gray-500 dark:hover:text-gray-400") {{ title }}

    .navbar-actions.flex.items-center.gap-3.flex-1(
        class="sm:justify-end justify-between"
    )
        BaseNavbarNotification.block(class="sm:hidden")
        //- BaseNavbarSearch
        .flex.hidden(class="sm:block" v-if="$slots.right")
            slot(name="right")
        .flex.gap-3.flex-1.justify-end
            BaseNavbarNotification.hidden(class="sm:block")
            BaseNavbarMenu
            UButton(
                variant="soft"
                size="sm"
                icon="material-symbols:fullscreen-rounded"
                color="secondary"
                @click="RFullScreen()"
            )

//- +++++++++++++++++++++++++++++++++++
//- LARGE
//- +++++++++++++++++++++++++++++++++++
.w-full.flex.block.bg-white(
    class="sm:hidden"
    :class="{'border-b': !cls.includes('border-0') && cls !== ''}"
)
    .flex.h-full.flex-1.justify-between(
        class="flex-col font-bold text-sm text-gray-800 dark:text-gray-200 hover:text-gray-500 dark:hover:text-gray-400"
        :class="{'flex-row border-b': row, 'border-b': cls === ''}"
    )
        .flex.flex-1.gap-3.px-4.py-2
            .flex.self-center(v-if="!hideLink && $route.path !== '/'")
                UButton.cursor-pointer(
                    icon="mdi:chevron-left"
                    color="secondary"
                    size="sm"
                    variant="soft"
                    :to="pageUp"
                )

            .flex.flex-1.self-center(
                v-if="title || !!$slots.title"
            )
                slot(name="title")
                    .word-wrap {{ title }}

            ClientOnly
                .flex(id="navbar-right")

            //- if sidebar is activated
            .flex.self-center(
                v-if="sidebar"
            )
                UButton.cursor-pointer(
                    color="secondary"
                    variant="soft"
                    size="sm"
                    icon="i-lucide-menu"
                    label="Menu"
                    @click="store.sidebarOverlay = !store.sidebarOverlay"
                )

            slot(name="right")

        //- +++++++++++++++++++++++++
        //- Custom menu di kanan
        //- +++++++++++++++++++++++++
        .flex.h-full.self-center(
            v-if="$slots.default"
            :class="{'px-4': row}"
        )
            .flex.self-center.w-full.justify-end
                .flex.self-center
                    slot

.flex.self-center.bg-white(v-if="$slots.default && size")
    slot(name="default")

//- ClientOnly
    Teleport(to="#navbar-right")
        slot(name="right")

USlideover(
    v-model:open="store.sidebarOverlay"
    side="left"
    :overlay="true"
    :close="false"
    class="max-w-56"
    :ui="{body: 'p-0'}"
)
    template(#body)
        slot(name="sidebar" v-if="store.sidebarOverlay")

</template>
<script setup lang="ts">
import { breakpointsTailwind, useBreakpoints } from "@vueuse/core";
import { useRoute } from "vue-router";
const store = useTemplateStore();
const props = defineProps<{
  title?: string;
  hideLink?: boolean;
  row?: boolean;
  class?: string;
  sidebar?: boolean;
  right?: any;
}>();
const breakpoints = useBreakpoints(breakpointsTailwind);
const size = ref(breakpoints.greater("sm"));
const route = useRoute();
const pageUp = ref("");
const cls = ref("");
onMounted(() => {
  const segments = route.path.split("/").filter(Boolean);
  pageUp.value =
    segments.length > 1 ? `/${segments.slice(0, -1).join("/")}` : "/";

  if (props.class) {
    cls.value = props.class.toString();
  }
});
</script>
